import { TRESPONSE_GET_FACTORY_UOM } from '@monorepo/types';
import { TLiftedFormModel } from '../../model/form.model';
import { PIPELINE_FORM } from '../../model/form.pipeline';

type TDepartmentUom = TRESPONSE_GET_FACTORY_UOM['assigned_uom_by_department'];
type TDepartmentWiseUoms = TRESPONSE_GET_FACTORY_UOM['available_uoms_by_department'];

const isReadOnly = (
  assignedUom: string | undefined,
  currentDepartmentOptions: TDepartmentWiseUoms[number],
): boolean => {
  if (assignedUom && currentDepartmentOptions.uoms.length === 1 && assignedUom === currentDepartmentOptions.uoms[0]) {
    return true;
  } else {
    return false;
  }
};

const getInputs = (
  assignedUomByDepartment: TDepartmentUom,
  availableUombByDepartment: TDepartmentWiseUoms,
): TLiftedFormModel['inputs'] => {
  return availableUombByDepartment.map((uomByDepartment) => {
    return {
      input: {
        type: 'DROPDOWN',
        value: assignedUomByDepartment[uomByDepartment.department],
        placeholder: 'Choose Unit',
        options: uomByDepartment['uoms'].map((d) => ({ value: d, displayName: d })),
      },
      metadata: {
        keyName: uomByDepartment['department'],
        label: uomByDepartment['department'],
        isRequired: true,
        isDisabled: isReadOnly(assignedUomByDepartment[uomByDepartment.department], uomByDepartment),
      },
    };
  });
};

export const ENTER_UOM_FORM_MODEL = {
  createModel: (
    assignedUomByDepartment: TDepartmentUom,
    availableUombByDepartment: TDepartmentWiseUoms,
  ): TLiftedFormModel => {
    return PIPELINE_FORM.sanitize({
      inputs: getInputs(assignedUomByDepartment, availableUombByDepartment),
      isValid: false,
      colConfig: 'SINGLE_COL',
    });
  },
  identity: (): TLiftedFormModel => {
    return {
      inputs: [],
    };
  },
};
